exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2dvDR{padding-left:0;padding-right:0}._1VRb7{margin:0 auto;padding:0 0 40px;margin-top:30px;max-width:1080px}", ""]);

// exports
exports.locals = {
	"root": "_2dvDR",
	"container": "_1VRb7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/cancel/Cancel.css
// module id = 2614
// module chunks = 15